//Content.js
import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import HomePage from '../neo/HomePage';
import {globalConfig} from '../../config/config';

function HomepageNeo() {


        return (
        <>
        	<HomePage />
        {/*
        	<iframe width="100%" frameborder="false" height="900" src={globalConfig.neoUrl} />
        */}
        </>
			)
}
export default HomepageNeo; 
